/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const loginPageStyle = {
  container: (theme: Theme) => ({
    paddingBlock: "4rem",
    [theme.breakpoints.up("sm")]: {
      paddingBlock: "6rem 9rem",
    },
  }),
  card: (theme: Theme) => ({
    padding: "1rem",
    [theme.breakpoints.up("sm")]: {
      padding: "3rem",
    },
  }),
};

export default loginPageStyle;
